import React from 'react';
import PropTypes from 'prop-types';

import Metrics from '@spotahome/soyuz-metrics';
import { trans } from '@spotahome/soyuz/client';

import FilterGroup from '../FilterGroup';
import FormDatePicker from '../../../ui/form/form-datepicker';

const DatePickerFilter = ({
  flexibleMoveIn,
  flexibleMoveOut,
  from,
  minimumStaying,
  to,
  updateFiltersWith
}) => (
  <FilterGroup
    classModifier="datepicker"
    label={trans('search.filter.enter.dates')}
  >
    <FormDatePicker
      flexibleDates={{
        flexibleMoveIn: flexibleMoveIn === 1,
        flexibleMoveOut: flexibleMoveOut === 1,
        onFlexibleMoveInChange: value => {
          const converted = value ? 1 : 0;
          Metrics.ga.sendEvent(
            'Search',
            'FlexibleMoveIn checkbox',
            `${converted}`
          );
          updateFiltersWith({ flexibleMoveIn: converted });
        },
        onFlexibleMoveOutChange: value => {
          const converted = value ? 1 : 0;

          Metrics.ga.sendEvent(
            'Search',
            'FlexibleMoveOut checkbox',
            `${converted}`
          );
          updateFiltersWith({ flexibleMoveOut: converted });
        }
      }}
      fromDate={from}
      minimumStaying={minimumStaying}
      onChange={updateFiltersWith}
      toDate={to}
    />
  </FilterGroup>
);

DatePickerFilter.propTypes = {
  flexibleMoveIn: PropTypes.bool,
  flexibleMoveOut: PropTypes.bool,
  updateFiltersWith: PropTypes.func.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  minimumStaying: PropTypes.number.isRequired
};

DatePickerFilter.defaultProps = {
  flexibleMoveIn: false,
  flexibleMoveOut: false
};

export default DatePickerFilter;
